import { Controller } from "@hotwired/stimulus";
import { rebind } from "../../config/initializers/rebind";
import { apiWeb } from "@/javascripts/utils/api/wordrabbit/web";
import { getXmlHttpRequestHeader } from "@/javascripts/utils/api/wordrabbit/headers.ts";

export default class extends Controller {
  //
  // life cycle
  //
  initialize() {
    // aタグをSPAにハックする
    if (location.pathname != "/writing_professionals/search") {
      $(this.targets.element).on("click", "a", (e) => {
        this.link(e);
      });
    }
    // ブラウザバック
    $(window).on("popstate", (e) => {
      location.reload();
    });

    // SPページフッターを隠す
    $(window).scroll(() => {
      this.spPageFooterClose();
    });
  }

  //
  // target
  //
  static targets = ["yield", "data", "menu", "nav", "navFloat"];

  //
  // public methods
  //
  link(e) {
    // writing_professional内のリンクは以外は通常動作にする
    if (!e.target) {
      return;
    }
    const href = $(e.target).attr("href");
    if (!href) {
      return;
    }
    if (href.slice(0, 27).indexOf("/writing_professionals/prow") == -1) {
      return;
    }
    e.preventDefault();
    this.show(href);
  }
  //
  // private methods SPA画面遷移
  //
  async show(href) {
    const headers = getXmlHttpRequestHeader();
    const { data } = await apiWeb.get(href, headers);
    if (!data) {
      return;
    }
    this.yieldTarget.innerHTML = data;
    rebind(this.yieldTarget);

    // SPAの後処理
    this.callGoogleTagManager();
    history.pushState(null, null, href);

    this.updateMetaTag();
    this.updateListDom();
    this.scrollTop();
    window.components.menuSpSub.close();
  }

  // private
  updateMetaTag() {
    const $dataTarget = $(this.dataTarget);
    document.title = $dataTarget.data("meta-title");
    $("meta[name=description]").attr("content", $dataTarget.data("meta-description"));
    $("meta[property=og\\:title]").attr("content", $dataTarget.data("meta-sns-title"));
    $("meta[property=og\\:image]").attr("content", $dataTarget.data("meta-sns-image"));
    $("meta[name=twitter\\:title]").attr("content", $dataTarget.data("meta-sns-title"));
    $("meta[name=twitter\\:image]").attr("content", $dataTarget.data("meta-sns-image"));
  }
  updateListDom() {
    const $dataTarget = $(this.dataTarget);
    const slug = $dataTarget.data("slug");
    const $menuTargets = $(this.menuTargets);
    $menuTargets.find("li").each((index, list) => {
      const $list = $(list);
      if ($list.data("slug") === slug) {
        $list.addClass("active");
      } else {
        $list.removeClass("active");
      }
    });
    // spSubのタイトルを更新
    // window.components.menuSpSub.title($dataTarget.data("meta-title-menu"));
  }
  scrollTop() {
    window.scrollTo({ top: 0, behavior: "instant" });
  }
  callGoogleTagManager() {
    // GA4はSPAに対応しているので、PageViewだけならば自動で送信される。(user_engagementイベントは送信されない)
  }
  spPageFooterClose() {
    //ページ全体の高さ
    const $nav = $(this.navTarget);
    const $navFloat = $(this.navFloatTarget);

    const currentPointY = window.pageYOffset;
    const breakPoint = $nav.offset().top - window.innerHeight;

    if (currentPointY > breakPoint) {
      $navFloat.addClass("style-fadeout");
    } else {
      $navFloat.removeClass("style-fadeout");
    }
  }
  isSp() {
    if (window.innerWidth < 768) {
      return true;
    } else {
      return false;
    }
  }
}
